import inboxZeroImg from '../../../assets/tasks-framework/tasks-overview-inbox-zero.svg';

// TODO: Add other states
export const TasksOverviewZeroState = () => {
  return (
    <div className="rounded-lg border border-teal-350 bg-teal-100 text-zinc-800 sm:flex">
      <div className="mx-10 mt-10 flex grow flex-col justify-center gap-y-2 sm:mt-0">
        <h2 className="text-2xl font-bold">Inbox zero</h2>
        <p>You have no outstanding tasks!</p>
      </div>

      <img
        className="ml-auto max-h-48 shrink object-cover md:max-h-full lg:max-h-48 xl:max-h-full"
        src={inboxZeroImg}
        alt=""
      />
    </div>
  );
};
